import EmblaCarousel from "embla-carousel"

export function initTeamCarousel() {
  const emblaNode = document.querySelector("[data-team-carousel]")

  if (!emblaNode) {
    return
  }

  const container = emblaNode.querySelector(".embla__container")

  if (!container) {
    return
  }

  let emblaApi = null

  const init = () => {
    // Only initialize Embla below lg
    if (window.innerWidth < 1024 && !emblaApi) {
      emblaApi = EmblaCarousel(emblaNode, {
        align: "start",
        containScroll: "trimSnaps",
        dragFree: true
      })

      return
    }

    // Destroy Embla when reaching desktop
    if (window.innerWidth >= 1024 && emblaApi) {
      emblaApi.destroy()
      emblaApi = null
    }
  }

  init()

  let resizeTimeout

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout)

    resizeTimeout = setTimeout(() => {
      init()
    }, 150)
  })
}

export function initServiceCarousel() {
  const emblaNode = document.querySelector("[data-service-carousel]")

  if (!emblaNode) {
    return
  }

  const container = emblaNode.querySelector(".embla__container")

  if (!container) {
    return
  }

  // Find the controls relative to the carousel wrapper (or section)
  const wrapperNode = emblaNode.closest("section") || emblaNode.parentElement
  const prevBtn = wrapperNode.querySelector(".embla__prev")
  const nextBtn = wrapperNode.querySelector(".embla__next")
  const dotsContainer = wrapperNode.querySelector(".embla__dots")

  // 1. Initialize Embla
  const emblaApi = EmblaCarousel(emblaNode, {
    axis: "x",
    align: "start",
    containScroll: "trimSnaps",
    dragFree: true
  })

  // 2. Setup Dots
  let dots = []
  const setupDots = () => {
    if (!dotsContainer) return
    dotsContainer.innerHTML = "" // Clear existing dots

    const scrollSnaps = emblaApi.scrollSnapList()
    dots = scrollSnaps.map((_, index) => {
      const dot = document.createElement("button")
      dot.type = "button"
      // Tailwind classes for active vs inactive state
      dot.className = "w-3 h-3 rounded-full bg-gray-300 transition-all duration-200 cursor-pointer"
      dot.setAttribute("aria-label", `Go to slide ${index + 1}`)
      dot.addEventListener("click", () => emblaApi.scrollTo(index))
      dotsContainer.appendChild(dot)
      return dot
    })
  }

  // 3. Update UI states (Button disabled states & Active dot styling)
  const updateUI = () => {
    // Disable buttons at bounds
    if (prevBtn) prevBtn.disabled = !emblaApi.canScrollPrev()
    if (nextBtn) nextBtn.disabled = !emblaApi.canScrollNext()

    // Highlight active dot
    if (dots.length) {
      const selectedIndex = emblaApi.selectedScrollSnap()
      dots.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.className = "w-6 h-3 rounded-full bg-yaitso-red-dark transition-all duration-200 cursor-pointer"
        } else {
          dot.className = "w-3 h-3 rounded-full bg-gray-300 transition-all duration-200 cursor-pointer"
        }
      })
    }
  }

  // 4. Attach Event Listeners
  if (prevBtn) {
    prevBtn.addEventListener("click", () => emblaApi.scrollPrev())
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => emblaApi.scrollNext())
  }

  // Setup initial state and subscribe to Embla events
  setupDots()
  updateUI()

  emblaApi.on("select", updateUI)
  emblaApi.on("reInit", () => {
    setupDots()
    updateUI()
  })
}